/**
 * Renders a small icon indicating which Firebase Auth provider the user signed
 * up with. Google sign-in gets the multicolor G mark; everything else (and
 * legacy users without a recorded providerId) gets a generic envelope.
 */
interface Props {
  providerId: string | null;
  size?: number;
}

export function ProviderBadge({ providerId, size = 16 }: Props) {
  if (providerId === "google.com") {
    return (
      <span
        title="Signed in with Google"
        aria-label="Google"
        className="acx__provider-badge"
        style={{ width: size, height: size }}
      >
        <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true">
          <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3l5.7-5.7C34.5 6.1 29.5 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.3-.4-3.5z" />
          <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16 19 13 24 13c3.1 0 5.8 1.2 7.9 3l5.7-5.7C34.5 6.1 29.5 4 24 4c-7.7 0-14.4 4.4-17.7 10.7z" />
          <path fill="#4CAF50" d="M24 44c5.4 0 10.3-2.1 14-5.4l-6.5-5.5C29.5 34.5 26.9 35 24 35c-5.3 0-9.7-3.3-11.3-8L6.1 31.4C9.3 38.7 16 44 24 44z" />
          <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.2 4.3-4.1 5.7l6.5 5.5C40.1 35.5 44 30.2 44 24c0-1.3-.1-2.3-.4-3.5z" />
        </svg>
      </span>
    );
  }
  return (
    <span
      title={providerId === "password" ? "Signed up with email/password" : "Unknown provider"}
      aria-label={providerId ?? "unknown"}
      className="acx__provider-badge"
      style={{ width: size, height: size }}
    >
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <rect x="3" y="5" width="18" height="14" rx="2" />
        <path d="m3 7 9 6 9-6" />
      </svg>
    </span>
  );
}
